<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-grid-beat" [fullScreen]="true">
    <p style="color: white"> Please Wait...</p>
</ngx-spinner>

<div class="header_second">
    <div class="Dashboard_head ">Stall
        <div style="text-align: end;" class="col-xl-6 col-lg-9 col-md-9 col-sm-9 col-6 p-0">
            <button mat-stroked-button color="primary" style=" font-size: 14px; margin-right: 15px;"
                (click)="stallLayout()"><mat-icon>map</mat-icon>Stall Layout</button>

            <button mat-raised-button color="primary" style="font-size: 14px;
                    margin-right: 15px;" (click)="AddStall(null)"><mat-icon>add</mat-icon>Add</button>
        </div>
    </div>
</div>

<div class="mat-elevation-z8" style="margin: 0.5rem;">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Search</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search" #input>
    </mat-form-field>
    <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort>

            <!-- Position Column -->
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> ID. </th>
                <td mat-cell *matCellDef="let element"> {{element.srNo}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="price">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Price </th>
                <td mat-cell *matCellDef="let element"> {{element.price}} </td>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
                <td mat-cell *matCellDef="let element"> {{element.status}} </td>
            </ng-container>

            <ng-container matColumnDef="stall_num">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Stall</th>
                <td mat-cell *matCellDef="let element"> {{element.stall_num}} </td>
            </ng-container>
            <ng-container matColumnDef="size">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Size</th>
                <td mat-cell *matCellDef="let element"> {{element.size}} ft</td>
            </ng-container>
            <ng-container matColumnDef="owner_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Stall Owner</th>
                <td mat-cell *matCellDef="let element"> {{element.owner_name ? element.owner_name : '-'}} </td>
            </ng-container>
            <ng-container matColumnDef="owner_number">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Number</th>
                <td mat-cell *matCellDef="let element"> {{element.owner_number ? element.owner_number : '-'}} </td>
            </ng-container>

            <ng-container matColumnDef="assign_owner" stickyEnd justify="end">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Assign Owner </th>
                <td mat-cell *matCellDef="let element">
                    <button mat-raised-button matTooltip="Assign Stall Owner"
                        style="margin-left: 5px; background: green;color: white;"
                        (click)="AddStallOwner(element.so_id,element.id,element.stall_num)">
                        <mat-icon class="m-0">
                            {{ element.so_id ? 'edit' : 'add' }}
                        </mat-icon></button>
                </td>
            </ng-container>
            <ng-container matColumnDef="action" stickyEnd justify="end">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Action </th>
                <td mat-cell *matCellDef="let element">
                    <button mat-raised-button color="primary" matTooltip="Edit" style="margin-left: 5px;"
                        (click)="AddStall(element.id)">
                        <mat-icon class=" m-0">edit</mat-icon>
                    </button>
                    <button mat-raised-button color="warn" matTooltip="Delete" [hidden]="element.status == 'admin'"
                        style="margin-left: 5px;" (click)="DeleteStall(element.id)">
                        <mat-icon class=" m-0">delete</mat-icon>
                    </button>

                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons aria-label="Select page of periodic elements">
    </mat-paginator>
</div>